import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import MaterialTypography from "../../../components/MaterialTypography";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Stack,
  Button,
  TextField,
} from "@mui/material";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import moment from "moment-timezone";
import Swal from "sweetalert2";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import { useUserDetails } from "../../../context/auth";
function WFHApproval() {
  const [employeeData, setemployeeData] = useState([]);
  const { Manager, setManager, HRRole, AccessData } = useUserDetails();
  const [display, setdisplay] = useState(false);
  const navigate = useNavigate();
  const [ID, setID] = useState("");

  let Roledata = JSON.parse(sessionStorage.getItem("WFHApp"));

  const [Alldata, setAlldata] = useState("");
  
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setID(id);
    if (id) {
      getInitData(id);
    }
  }, []);

  const getInitData = async (id) => {
    const query = `  query user_wfh_details($id:String!){
  getWfhById(id:$id){
    id
    requestedDate
      startDate
      endDate
      reason
      status
      totalDays
      task
      teamApproval
      hrApproval
      lastUpdate
      user{
        id
        firstName
      }
  }
} `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const weekoffRowdata = response.data.data.getWfhById;

      setemployeeData(weekoffRowdata);
      setAlldata(weekoffRowdata);

      if (
        AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) =>
            item.module === "WFHManagement" &&
            item.component === "ManagerApproval" &&
            item.can_access
        )
      ) {

        if (weekoffRowdata.teamApproval == "Pending") {
          setdisplay(true);
        }else {
          setdisplay(false);
        }

        // setdisplay(true);
      } else if (
        AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) =>
            item.module === "WFHManagement" &&
            item.component === "HrApproval" &&
            item.can_access
        )
      ) {
        if (Roledata == "HRList") {
          if (weekoffRowdata.teamApproval == "Pending") {
            setdisplay(true);
          }
        } else if (Roledata == "HR") {
          if (
            weekoffRowdata.teamApproval == "approved" &&
            weekoffRowdata.hrApproval == "Pending"
          ) {
            setdisplay(true);
          }
        }
      }

      // if(Manager){
      //   setdisplay(true)
      //   return
      // }
      // if(weekoffRowdata.teamApproval == 'approved'){

      //   setdisplay(true)
      // }else if(weekoffRowdata.teamApproval == 'rejected'){
      //   setdisplay(false)
      // }
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };
  // const checkInTime = moment(employeeData.checkIn).tz('Your/Timezone', true).format('M/D/YYYY, h:mm:ss a');
  // const checkOutTime = moment(employeeData.checkOut).tz('Your/Timezone', true).format('M/D/YYYY, h:mm:ss a');

  //     const ApproveSubmit = async (statusdata) => {
  //       let query;

  //       if (AccessData && Array.isArray(AccessData) && AccessData.some(item => item.module === 'WFHManagement' && item.component === 'HrApproval' && item.can_access)) {

  //         query = `
  //         mutation WFHHrApproval($id:String!
  //   $status:String!
  // ){
  //   WfhApprovalHR(id:$id status:$status){
  //     wfhApprovalHR{
  //       requestedDate
  //       startDate
  //       endDate
  //       reason
  //       totalDays
  //       task
  //       teamApproval
  //       hrApproval
  //       lastUpdate
  //       user{
  //         id
  //         username
  //       }
  //     }
  //   }
  // }

  //         `;
  //       } else if (AccessData && Array.isArray(AccessData) && AccessData.some(item => item.module === 'WFHManagement' && item.component === 'ManagerApproval' && item.can_access)){

  //         query = `
  //        mutation WFHManagerApproval($id:String!
  //   $status:String!
  //   $task:String!
  // ){
  //   WfhManagerApproval(id:$id status:$status task:$task){
  //     wfhApprovalManager{
  //       requestedDate
  //       startDate
  //       endDate
  //       reason
  //       totalDays
  //       teamleaderId
  //       task
  //       teamApproval
  //       status
  //       hrApproval
  //       lastUpdate
  //       user{
  //         id
  //         username
  //       }
  //     }
  //   }
  // }
  //         `;
        // }

  // //       if (HRRole) {

  // //         console.log('HRRR');

  //         query = `

  // mutation WFHHrApproval($id:String!
  //   $status:String!
  // ){
  //   WfhApprovalHR(id:$id status:$status){
  //     wfhApprovalHR{
  //       requestedDate
  //       startDate
  //       endDate
  //       reason
  //       totalDays
  //       task
  //       teamApproval
  //       hrApproval
  //       lastUpdate
  //       user{
  //         id
  //         username
  //       }
  //     }
  //   }
  // }

  //           `;
  // //       } else if (Manager) {
  // //         console.log('Manager');
  // //         query = `
  // //           mutation WFHManagerApproval($id:String!
  // //   $status:String!
  // //   $task:String!
  // // ){
  // //   WfhManagerApproval(id:$id status:$status task:$task){
  // //     wfhApprovalManager{
  // //       requestedDate
  // //       startDate
  // //       endDate
  // //       reason
  // //       totalDays
  // //       teamleaderId
  // //       task
  // //       teamApproval
  // //       status
  // //       hrApproval
  // //       lastUpdate
  // //       user{
  // //         id
  // //         username
  // //       }
  // //     }
  // //   }
  // // }

  // //           `;
  // //       } else {
  // //         console.error("Neither HRregularization nor managerState is true.");
  // //         return; // Exit if no condition is met
  // //       }

  //       const variables = {
  //         id: ID,
  //         status: statusdata,
  //         task:"task"
  //       };

  //       try {
  //         const response = await axios.post(
  //           BASEURL, // Replace with your actual GraphQL endpoint
  //           {
  //             query: query,
  //             variables: variables,
  //           },
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //             },
  //           }
  //         );

      //     // console.log(
      //     //   "Response:",
      //     //   response.data.data.regularizationApproval.regularizationApprovalHR
      //     // );
      //     if (
      //       response.data.data?.WfhApprovalHR?.wfhApprovalHR
      //     ) {
      //       Swal.fire({
      //         position: "center",
      //         icon: "success",
      //         title: "Approved successfully!",
      //         showConfirmButton: false,
      //         timer: 2500,
      //       });
      //       navigate('/wfh-management')
      //     } else if (
      //       response.data.data?.WfhManagerApproval?.wfhApprovalManager
      //     ) {
      //       Swal.fire({
      //         position: "center",
      //         icon: "success",
      //         title: "Approved successfully!",
      //         showConfirmButton: false,
      //         timer: 2500,
      //       });
      //       navigate('/wfh-management')
      //     }
      //     // Handle success (e.g., show a success message or navigate)
      //   } catch (error) {
      //     console.error("Error in ApproveSubmit:", error);
      //     // Handle error (e.g., show a user-friendly error message)
      //   }
      // };

  const handleAddLeave = (statusdata) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are you sure you want to ${
        statusdata == "approved"
          ? "Approve"
          : statusdata == "rejected"
          ? "Reject"
          : ""
      } the leave?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ApproveSubmit(statusdata);
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const ApproveSubmit = async (statusdata) => {
    let query;

    if (
      AccessData &&
      Array.isArray(AccessData) &&
      AccessData.some(
        (item) => item.component === "HrApproval" && item.can_access
      )
    ) {
      if (Roledata == "HRList") {
        if (Alldata.teamApproval == "Pending") {

          query = `mutation WFHManagerApproval($id:String!
     $status:String!
     $task:String!
   ){
     WfhManagerApproval(id:$id status:$status task:$task){
       wfhApprovalManager{
         requestedDate
         startDate
         endDate
         reason
         totalDays
         teamleaderId
         task
         teamApproval
         status
         hrApproval
         lastUpdate
         user{
           id
           username
         }
       }
     }
   }
           `;
        }
      } else if (
        Roledata == "HR" &&
        Alldata.teamApproval == "approved" &&
        Alldata.hrApproval == "Pending"
      ) {
        
        query = `mutation WFHHrApproval($id:String!
          $status:String!
        ){
          WfhApprovalHR(id:$id status:$status){
            wfhApprovalHR{
              requestedDate
              startDate
              endDate
              reason
              totalDays
              task
              teamApproval
              hrApproval
              lastUpdate
              user{
                id
                username
              }
            }
          }
        }
      
                  `;
      }
    } else {
      query = `mutation WFHManagerApproval($id:String!
 $status:String!
 $task:String!
){
 WfhManagerApproval(id:$id status:$status task:$task){
   wfhApprovalManager{
     requestedDate
     startDate
     endDate
     reason
     totalDays
     teamleaderId
     task
     teamApproval
     status
     hrApproval
     lastUpdate
     user{
       id
       username
     }
   }
 }
}
       `;
    }

  
    const variables = {
      id: ID,
      status: statusdata,
      task:"task"
    };


    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      //   "Response:",
      //   response.data.data.regularizationApproval.regularizationApprovalHR
      // );
      if (
        response.data.data?.WfhApprovalHR?.wfhApprovalHR
      ) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${
            statusdata.charAt(0).toUpperCase() + statusdata.slice(1)
          } successfully!`,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate('/wfh-management')
      } else if (
        response.data.data?.WfhManagerApproval?.wfhApprovalManager
      ) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${
            statusdata.charAt(0).toUpperCase() + statusdata.slice(1)
          } successfully!`,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate('/wfh-management')
      }
      // Handle success (e.g., show a success message or navigate)
    } catch (error) {
      console.error("Error in ApproveSubmit:", error);
      // Handle error (e.g., show a user-friendly error message)
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // This will return 'dd/mm/yyyy' format
  }

  const handleclose = () => {
    navigate("/wfh-management");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ padding: 1, boxShadow: 4, borderRadius: 2 }}>
        {/* Card Title */}
        <CardHeader
          title={
            <Typography
              variant="h5"
              fontWeight="bold"
              textAlign="center"
              gutterBottom
            >
              WFH Details
            </Typography>
          }
        />

        {/* Leave Details Content */}
        <CardContent>
          <Grid container spacing={1} marginLeft={"4%"}>
            {/* Left Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>User Name:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.user?.firstName?.toUpperCase()}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Start Date:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.startDate}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>End Date:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.endDate}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Total Days:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.totalDays}
                  </span>
                </Typography>
              </Stack>
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>Reason:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.reason}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Manager Approval:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.teamApproval == "approved"
                      ? "Approved"
                      : employeeData?.teamApproval == "rejected"
                      ? "Rejected"
                      : employeeData?.teamApproval}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>HR Approval:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.hrApproval == "approved"
                      ? "Approved"
                      : employeeData?.hrApproval == "rejected"
                      ? "Rejected"
                      : employeeData?.hrApproval}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Status:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.status == "approved"
                      ? "Approved"
                      : employeeData?.status == "rejected"
                      ? "Rejected"
                      : employeeData?.status}
                  </span>
                </Typography>
              </Stack>
            </Grid>
          </Grid>

          {/* Buttons */}
          <Grid container spacing={2} justifyContent="center" marginTop={4}>
            {display && (
              <>
                <Grid item>
                  <MaterialButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleAddLeave("approved")}
                  >
                    Approve
                  </MaterialButton>
                </Grid>
                <Grid item>
                  <MaterialButton
                    variant="contained"
                    color="secondary"
                    onClick={() => handleAddLeave("rejected")}
                  >
                    Reject
                  </MaterialButton>
                </Grid>
              </>
            )}
            <Grid item>
              <MaterialButton
                variant="contained"
                color="dark"
                onClick={() => handleclose()}
              >
                Close
              </MaterialButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default WFHApproval;
